module.exports = __webpack_public_path__ + "static/media/verifyOrange.f13d1458.svg";